import {createApiClient} from "./index";
import {generateQueryParams} from "helpers/common";
import {TeamsDto, TeamsQueryParams} from "types/teams";

export const teamsApi = {
    async getTeams({
                       filters,
                       token,
                       params,
                       apiKey
                   }: TeamsQueryParams, signal?: AbortSignal): Promise<TeamsDto> {
        const api = createApiClient(apiKey);

        const data = Object.fromEntries(
            Object.entries(filters).filter(([_, value]) => !!value || value === 0)
        );

        const queryParams = generateQueryParams(params);

        const response = await api.post(`/teams/filter${queryParams}`, {
            ...data,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            signal,
        });
        return response.data;
    },
};
